import { BrandDeviceCateObject, OrderObject, ProductObject } from "./Constants";

export const notificationData = [
    {
        image: '/products/image_35.png',
        time: 'A moment ago',
        action: 'viewed',
        object: '508386 Sennheiser HD 450BT - Black',
        toWhere: '',
        type: 'product'
    },
    {
        image: '/products/image_35.png',
        time: 'A moment ago',
        action: 'added',
        object: '508386 Sennheiser HD 450BT - Black',
        toWhere: 'your favourites',
        type: 'product'
    },
    {
        image: '/products/image_7.png',
        time: '1 hour ago',
        action: 'ordered',
        object: 'MRQC2PA/A Beats Solo3 Wireless On-Ear - Decade collection',
        toWhere: '',
        type: 'product'
    },
    {
        image: '/pin-1.svg',
        time: 'Yesterday at 09:50am',
        action: 'added',
        object: 'new address',
        toWhere: '',
        type: 'address'
    },
    {
        image: '/messages-people-user-bubble-circle.svg',
        time: 'August 22 at 12:00pm',
        action: 'sent',
        object: 'new request',
        toWhere: '',
        type: 'request'
    }
]

export const productSample: Array<ProductObject> = [
    { id: '', value: '508380', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 0, rrprice: 0 },
    { id: '', value: '508381', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 0, rrprice: 0 },
    { id: '', value: '508382', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 0, rrprice: 0  }
];

export const recommendedProduct: Array<ProductObject> = [
    { id: '', value: 'MRQC2PA/A', name: 'Braven 105 Waterproof Headphone - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95},
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95 },
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95},
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95},
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95},
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95},
    { id: '', value: 'MRQC2PA/A', name: 'Sennheiser CX 150BT In-ear - Black', image: 'image_7.png', bigImage: 'headphones.png', logo: 'beats_logo_menu.svg', link: '/product/1', price: 25.92, rrprice: 59.95}
];

export const orderSample: Array<OrderObject> = [
    {
        name: '#300219535',
        total: 1500,
        status: 'Processing',
        orderDate: '09/11/2020',
        orderLines: [
            {
                value: 'MRQC2PA/A',
                name: 'Beats Solo3 Wireless On-Ear - Decade Collection',
                qty: 20,
                price: 75,
                image: 'image_7.png',
                link: ''
            }
        ]
    },
    {
        name: '#300219536',
        total: 1500,
        status: 'Processing',
        orderDate: '09/11/2020',
        orderLines: [
            {
                value: 'MRQC2PA/A',
                name: 'Beats Solo3 Wireless On-Ear - Decade Collection',
                qty: 20,
                price: 75,
                image: 'image_7.png',
                link: ''
            }
        ]
    },
    {
        name: '#300219537',
        total: 1500,
        status: 'Processing',
        orderDate: '09/11/2020',
        orderLines: [
            {
                value: 'MRQC2PA/A',
                name: 'Beats Solo3 Wireless On-Ear - Decade Collection',
                qty: 20,
                price: 75,
                image: 'image_7.png',
                link: ''
            }
        ]
    }
]

export const brandList: Array<BrandDeviceCateObject> = [
    {
        name: '3SIXT',
        link: '/shop',
        image: '',
        logo: '3SIXT.svg'
    },
    {
        name: 'Airbolt',
        link: '/shop',
        image: '',
        logo: 'Airbolt.svg'
    },
    {
        name: 'Apple',
        link: '/shop',
        image: '',
        logo: 'Apple.svg'
    },
    {
        name: 'Beats',
        link: '/shop',
        image: '',
        logo: 'Beats.svg'
    },
    {
        name: 'Belkin',
        link: '/shop',
        image: '',
        logo: 'Belkin.svg'
    },
    {
        name: 'Bose',
        link: '/shop',
        image: '',
        logo: 'Bose.svg'
    },
    {
        name: 'Braven',
        link: '/shop',
        image: '',
        logo: 'Braven.svg'
    },
    {
        name: 'Dbramante',
        link: '/shop',
        image: '',
        logo: 'Dbramante.svg'
    },
    {
        name: 'Defunc',
        link: '/shop',
        image: '',
        logo: 'Defunc.svg'
    },
    {
        name: 'DLink',
        link: '/shop',
        image: '',
        logo: 'DLink.svg'
    },
    {
        name: 'Google',
        link: '/shop',
        image: '',
        logo: 'Google.svg'
    },
    {
        name: 'Griffin',
        link: '/shop',
        image: '',
        logo: 'Griffin.svg'
    },
    {
        name: 'Hewlett Packard',
        link: '/shop',
        image: '',
        logo: 'Hewlett Packard.svg'
    },
    {
        name: 'HUAWEI',
        link: '/shop',
        image: '',
        logo: 'HUAWEI.svg'
    },
    {
        name: 'iBaby',
        link: '/shop',
        image: '',
        logo: 'iBaby.svg'
    },
    {
        name: 'IFROGZ',
        link: '/shop',
        image: '',
        logo: 'IFROGZ.svg'
    },
    {
        name: 'Incase',
        link: '/shop',
        image: '',
        logo: 'Incase.svg'
    },
    {
        name: 'Incipio',
        link: '/shop',
        image: '',
        logo: '3SIXT.svg'
    },
    {
        name: 'Korjo',
        link: '/shop',
        image: '',
        logo: 'Korjo.svg'
    },
    {
        name: 'Lexar',
        link: '/shop',
        image: '',
        logo: 'Lexar.svg'
    },
    {
        name: 'Lifeproof',
        link: '/shop',
        image: '',
        logo: 'Lifeproof.svg'
    },
    {
        name: 'Logitech',
        link: '/shop',
        image: '',
        logo: 'Logitech.svg'
    },
    {
        name: 'Mophie',
        link: '/shop',
        image: '',
        logo: 'Mophie.svg'
    },
    {
        name: 'Mous',
        link: '/shop',
        image: '',
        logo: 'Mous.svg'
    },
    {
        name: 'Oppo',
        link: '/shop',
        image: '',
        logo: 'Oppo.svg'
    },
    {
        name: 'Optus',
        link: '/shop',
        image: '',
        logo: 'Optus.svg'
    },
    {
        name: 'Otterbox',
        link: '/shop',
        image: '',
        logo: 'Otterbox.svg'
    },
    {
        name: 'PanzerGlass',
        link: '/shop',
        image: '',
        logo: 'PanzerGlass.svg'
    },
    {
        name: 'Philips',
        link: '/shop',
        image: '',
        logo: 'Philips.svg'
    },
    {
        name: 'Poly',
        link: '/shop',
        image: '',
        logo: 'Poly.svg'
    },
    {
        name: 'PowerGuard',
        link: '/shop',
        image: '',
        logo: 'PowerGuard.svg'
    },
    {
        name: 'PowerShield',
        link: '',
        image: '',
        logo: 'PowerShield.svg'
    },
    {
        name: 'Q2 Power AG',
        link: '',
        image: '',
        logo: 'Q2 Power AG.svg'
    },
    {
        name: 'Samsung',
        link: '',
        image: '',
        logo: 'Samsung.svg'
    },
    {
        name: 'Sennheiser',
        link: '',
        image: '',
        logo: 'Sennheiser.svg'
    },
    {
        name: 'Square',
        link: '',
        image: '',
        logo: 'Square.svg'
    },
    {
        name: 'Strontium',
        link: '',
        image: '',
        logo: 'Strontium.svg'
    },
    {
        name: 'SUDIO',
        link: '',
        image: '',
        logo: 'SUDIO.svg'
    },
    {
        name: 'TECH21',
        link: '',
        image: '',
        logo: 'TECH21.svg'
    },
    {
        name: 'ThinOptics',
        link: '',
        image: '',
        logo: 'ThinOptics.svg'
    },
    {
        name: 'UBTECH',
        link: '',
        image: '',
        logo: 'UBTECH.svg'
    },
    {
        name: 'Ultimate Ears',
        link: '',
        image: '',
        logo: 'Ultimate Ears.svg'
    },
    {
        name: 'Urban Armour Gear',
        link: '',
        image: '',
        logo: 'Urban Armour Gear.svg'
    },
    {
        name: 'zagg',
        link: '',
        image: '',
        logo: 'zagg.svg'
    },
]

export const cateList: Array<BrandDeviceCateObject> = [
    {
        name: 'Accessories',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'Audio',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'Screen Protection',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'Power',
        link: '/shop',
        image: '',
        logo: '',
    }
]

export const deviceList: Array<BrandDeviceCateObject> = [
    {
        name: 'Top Sellers',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'Clearance',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'New',
        link: '/shop',
        image: '',
        logo: '',
    },
    {
        name: 'Special',
        link: '/shop',
        image: '',
        logo: '',
    }
]

export const CateMega = [
    'ACCESSORIES',
    'AUDIO',
    'POWER',
    'SCREEN PROTECTION'
]

export const VendorMega = [
    'APPLE',
    'SAMSUNG',
    'GOOGLE',
    'OPPO'
]

export const imageFallback = 'data:image/png;base64,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';